import { FC } from 'react';
import { Box, Flex, Palette, Text } from '@updater/ui-uds';
import { useHighlightsPromotions } from '@updater/ui-widgets';
import { Tag } from '@phosphor-icons/react';

export const PromotionsSection: FC = () => {
  const { promotions: highlightsPromotions } = useHighlightsPromotions();

  if (!highlightsPromotions?.length) return null;

  return (
    <Box mb="m">
      <Text variant="mBold" mb="s">
        Current promotions
      </Text>
      {highlightsPromotions.map((promo) => (
        <Flex key={promo.title} mb="s" alignItems="flex-start">
          <Box mr="s" flexShrink="0">
            <Tag size={22} color={Palette.mint600} weight="fill" />
          </Box>
          <Box>
            <Text variant="sBold">{promo.title}</Text>
            {promo.description && <Text variant="s">{promo.description}</Text>}
          </Box>
        </Flex>
      ))}
    </Box>
  );
};
